export type Bonus = {
  number: string
  title: string
  body: string
  /** Optional cover image. Empty = the CSS cover in the product palette. */
  cover?: string
  /** Tailwind bg class for the CSS cover's accent band. */
  accent: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Lane-to-Level Map',
    body: "Match the three lanes to the levels your club already uses — any country, any system — in ten minutes. A fill-in equivalence table and a guide to place every skill of the season in your own levels.",
    cover: 'https://cdn.magicpatterns.com/uploads/7ZEEtEhpzMPzDryrRoq9eZ/BONO_1.png',
    accent: 'bg-mint',
  },
  {
    number: '02',
    title: '3-Lane Lesson Builder',
    body: "Want to teach something that isn't in the plan this week? The blank Lesson Card and 3-Lane Circuit, with a worked example, so you can build your own lesson in 15 minutes.",
    cover: 'https://cdn.magicpatterns.com/uploads/upKf2tMHGFBjHde1pPB5gm/BONO_2.png',
    accent: 'bg-amber',
  },
  {
    number: '03',
    title: 'Rink Diagram Pad',
    body: 'Stop drawing circuits by hand. Eight top-down rink templates — full ice, half, thirds, three lanes, a numbered cone grid and more — ready to print or sketch on a tablet.',
    cover: 'https://cdn.magicpatterns.com/uploads/vZ5MMNe1Rm1UjwdteqVab2/BONO_3.png',
    accent: 'bg-glacier',
  },
  {
    number: '04',
    title: '52 Theme Weeks Calendar',
    body: 'Pirates, outer space, winter sports: a theme for every week that dresses up the lesson you already have without changing the technique — so the kids still want to come back mid-season.',
    cover: 'https://cdn.magicpatterns.com/uploads/rfCd4hgd92DKvQyxvg5gsB/BONO_4.png',
    accent: 'bg-lilac',
  },
  {
    number: '05',
    title: 'Skater Skills Passport',
    body: "A printable passport for every skater, with stamps by lane and 'Lane Up' certificates for the day someone moves up. First names or initials only.",
    cover: 'https://cdn.magicpatterns.com/uploads/wmWctG91mV3ng7sBTJWhEf/BONO_5.png',
    accent: 'bg-coral',
  },
]
